import React, { useState } from 'react'
import{Link, useNavigate}from 'react-router-dom'
import './Login.css'


function Login() {
    const[email,setEmail]=useState('')
    const[password,setPassword]=useState("")
    const user={email,password}
    const navigate=useNavigate();


    const handleChange=(e)=>{
      e.preventDefault();
      console.log(user);


      fetch("https://food-delivery-sid-api.herokuapp.com/api/login",{
        method:"POST",
        body:JSON.stringify(user),
        mode:'cors',
        headers:{
          'Content-Type': 'application/json'
        }
      })
      .then(data=>data.json())
      .then((data)=>{
        localStorage.setItem("jwt",data.accessToken)
        localStorage.setItem('name',data.user.name)
        localStorage.setItem('email',data.user.email)

        navigate('/')
        alert("you are Loged-in")
        // window.location.reload(false);
      })
      .catch(err=>{
        alert("credential are wronge")
      })

}

  return (
    <div className='con'>

        <div className='content1'>
          
            
      <form className='container11'>
      <h3>Login</h3>
        <label>Email or UserId</label>
        <input type="email" placeholder="userName" onChange={(e)=>{
            setEmail(e.target.value)
        }}/>
        <label>Password</label>
        <input type="password" placeholder="password" onChange={(e)=>{
            setPassword(e.target.value)
        }}/>

        <p>New to ZOMATO?</p>
        <Link to="/register"><p>create account</p></Link>
        <button onClick={handleChange}>Sign-In</button>
      </form>
      </div>
    </div>
  )
}

export default Login
